export const DIAMETER = 100;
const HALF = 0.5;
export const NEEDLE_BUTTON_WIDTH = 0.333;
export const NEEDLE_RADIANS = 0.1;

export const NEEDLE_WIDTH: number = DIAMETER / (Math.PI / NEEDLE_RADIANS);
export const RADIUS: number = DIAMETER * HALF;
